import { useParams } from "src/routes/hooks";
import Case from "./Case";

export default function CaseByID() {
  const params = useParams();
  const { id } = params;
  return <Case id={id} />;
}
